// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"aZ-z","subtitle":"bZ-z","wrapper":"cZ-z","leftArrow":"dZ-z","rightArrow":"eZ-z"};